/**
 * Editor Shortcuts Component
 * Invisible component that enables keyboard shortcuts inside the CraftEditor context
 */
import React from "react";
import { useEditorShortcuts } from "./hooks/useEditorShortcuts";

export const EditorShortcuts: React.FC = () => {
  // Just initialize the hook - it handles everything via useEffect
  useEditorShortcuts();

  // This component doesn't render anything
  return null;
};

export default EditorShortcuts;
